/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 */

import { actions as CommonActions } from "../reducers/app";
import types from "../actions/types";
import history from "../history/index";

export default function idleListener(dispatch) {
  let t;
  // let m;
  window.onload = resetTimer;
  window.onmousemove = resetTimer;
  window.onmousedown = resetTimer; // catches touchscreen presses as well
  window.ontouchstart = resetTimer; // catches touchscreen swipes as well
  window.onclick = resetTimer; // catches touchpad clicks as well
  window.onkeypress = resetTimer;
  window.addEventListener("scroll", resetTimer, true); // improved; see comments

  function showNotification() {
    dispatch(
      CommonActions.showNotification(
        "You have been inactive for 5 minute(s). You will be logged off automatically.",
        true,
        true,
        "info"
      )
    );
  }

  function logout() {
    dispatch({
      type: types.UNAUTH_USER,
      payload: "You have been inactive for 5 minute(s). You will be logged off automatically.",
    });
    sessionStorage.clear();
    history.push("/");
    history.replace("/");
    history.go("/");
    showNotification();
    dispatch(CommonActions.goOffline());
  }

  function resetTimer() {
    clearTimeout(t);
    // m = setTimeout(showNotification, 290000);  // time is in milliseconds
    t = setTimeout(logout, 300000); // time is in milliseconds
  }
}
